import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useStore from "../../../Hooks/useStore";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import AnnoucementComponent from "../../../Comp/Group/Annoucement/Annoucement";

const Announcement = () => {
  const axiosPrivate = useAxiosPrivate();
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [tableData, setTableData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const { fetchAgain } = useStore();

  useEffect(() => {
    const fetchCategories = async () => {
      const controller = new AbortController();
      const response = await axiosPrivate.get("/api/deals/showappdealsgroup", {
        signal: controller.signal,
      });
      const categories = response.data.data
        .filter((cat) => {
          return (
            (cat.active === true || cat.active === "true") &&
            (cat?.announcement === true || cat?.announcement === "true")
          );
        })
        .map((category) => ({
          value: category._id,
          label: category.name,
        }));

      setCategories(categories);
    };
    fetchCategories();
  }, [axiosPrivate]);

  // fetch announcements with pagination & search (server-side)
  useEffect(() => {
    const controller = new AbortController();
    const fetchAnnouncements = async () => {
      setLoading(true);
      try {
        let FETCH_TABLE_URL = `/api/deals/getdealannouncement?page=${
          page + 1
        }&limit=${rowsPerPage}`;
        if (searchTerm && searchTerm.trim() !== "") {
          FETCH_TABLE_URL += `&searchTerm=${encodeURIComponent(searchTerm)}`;
        }

        const response = await axiosPrivate.get(FETCH_TABLE_URL, {
          signal: controller.signal,
        });

        setTableData(response.data?.data || []);
        setTotalCount(
          response.data?.totalCount || (response.data?.data || []).length
        );
      } catch (error) {
        console.log(error, "Error fetching announcements");
        toast.error("Failed to load announcements.");
      } finally {
        setLoading(false);
      }
    };

    fetchAnnouncements();

    return () => controller.abort();
  }, [axiosPrivate, fetchAgain, page, rowsPerPage, searchTerm]);

  return (
    <AnnoucementComponent
      categories={categories}
      loading={loading}
      setSearchTerm={setSearchTerm}
      tableData={tableData}
      totalCount={totalCount}
      page={page}
      setPage={setPage}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={setRowsPerPage}
    />
  );
};
export default Announcement;
